module.exports = __webpack_public_path__ + "static/media/cloudupload.70819d94.gif";